import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppState } from "redux/store";

interface InitialState {
  loading: boolean;
  mintStatus: boolean | undefined;
}
const initialState: InitialState = {
  loading: false,
  mintStatus: undefined,
};

export const mintSlice = createSlice({
  name: "mint",
  initialState,
  reducers: {
    setMintLoading: (state) => {
      state.loading = true;
    },
    setMintStatus: (state, action: PayloadAction<boolean | undefined>) => {
      state.loading = false;
      state.mintStatus = action.payload;
    },
  },
});

export const { setMintLoading, setMintStatus } = mintSlice.actions;
export const mintSelector = (state: AppState) => state.mint;
export default mintSlice.reducer;
